import apiClient from '@/services/apiClient';

const BASE = '/inhouse/job-orders';

export const getJobbers = async () => {
  const { data } = await apiClient.get(`${BASE}/jobbers`);
  return data.jobbers || [];
};

export const getRateOptions = async (params = {}) => {
  const { data } = await apiClient.get(`${BASE}/rates/options`, { params });
  return data;
};

export const validateBundle = async (bundle_code, expected_sort_no = '') => {
  const { data } = await apiClient.post(`${BASE}/validate-bundle`, { bundle_code, expected_sort_no });
  return data;
};

export const createJobOrder = async (payload) => {
  const { data } = await apiClient.post(BASE, payload);
  return data;
};

export const listJobOrders = async (params = {}) => {
  const { data } = await apiClient.get(BASE, { params });
  return data;
};

export const getJobberReport = async (params = {}) => {
  const { data } = await apiClient.get(`${BASE}/report`, { params });
  return data;
};

export const getJobOrder = async (jw_id) => {
  const { data } = await apiClient.get(`${BASE}/${encodeURIComponent(jw_id)}`);
  return data;
};

export const getBundleUsns = async (jw_id) => {
  const { data } = await apiClient.get(`${BASE}/${encodeURIComponent(jw_id)}/bundle-usns`);
  return data;
};

export const returnJobOrder = async (jw_id, payload) => {
  const { data } = await apiClient.post(`${BASE}/${encodeURIComponent(jw_id)}/return`, payload);
  return data;
};

export const forceCloseJobOrder = async (jw_id, payload) => {
  const { data } = await apiClient.post(`${BASE}/${encodeURIComponent(jw_id)}/force-close`, payload);
  return data;
};
